import { oddsKeyArray } from '../oddsKeyArray'

const initMixin = () => {
  const mainAndSup = {
    mainKey: 'mixin',
    supKey: 'total_sum'
  }
  const triStraPair = ['TRIPLE', 'STRAIGHT', 'PAIR']
  const keyObj = {}
  let groupKey = ''

  keyObj['ANY:TRIPLE'] = {
    ...mainAndSup,
    groupKey: 'ANY:TRIPLE'
  }
  for (const oddsKey of triStraPair) {
    groupKey = `ANY:COMBO:${oddsKey}`
    keyObj[groupKey] = {
      ...mainAndSup,
      groupKey
    }
  }

  for (const oddsKey of oddsKeyArray) {
    keyObj[`ALL:SUM:${oddsKey}`] = {
      ...mainAndSup,
      groupKey: `ALL:SUM:${oddsKey}`
    }
    if (oddsKey === 'OVER' || oddsKey === 'UNDER') {
      keyObj[`ALL:SUM:${oddsKey}:EVEN`] = {
        ...mainAndSup,
        groupKey: `ALL:SUM:${oddsKey}:EVEN`
      }
      keyObj[`ALL:SUM:${oddsKey}:ODD`] = {
        ...mainAndSup,
        groupKey: `ALL:SUM:${oddsKey}:ODD`
      }
      keyObj[`ALL:SUM:EXT:${oddsKey}`] = {
        ...mainAndSup,
        groupKey: `ALL:SUM:EXT:${oddsKey}`
      }
    }
  }

  const oddsColorArray = ['RED', 'GREEN', 'BLUE']

  for (const color of oddsColorArray) {
    keyObj[`ALL:SUM:${color}`] = {
      ...mainAndSup,
      groupKey: `ALL:SUM:${color}`
    }
  }

  return keyObj
}

const initSP = () => {
  const keyObj = {}
  for (let i = 0; i <= 27; i++) {
    const groupKey = `ALL:SUM:${i}`
    keyObj[groupKey] = {
      mainKey: 'sp_num',
      supKey: '',
      groupKey
    }
  }

  return keyObj
}

export default {
  ...initMixin(),
  ...initSP()
}
